// extracted by mini-css-extract-plugin
export default {"modalContainer":"TheFullBackdrop_modalContainer__RJMK8","loaderBackdropContainer":"TheFullBackdrop_loaderBackdropContainer__jNacJ"};